// extracted by mini-css-extract-plugin
module.exports = {"container":"floatingToolbar_container__MCvlS","toolbar":"floatingToolbar_toolbar__tj7Ou","options":"floatingToolbar_options__NAIUT","hidden":"floatingToolbar_hidden__uLcgO"};